var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 28,
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 28",
    style: {
      enableBackground: "new 0 0 64 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#010412;}\n\t.st1{fill:#C02026;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.3,12.3L62.3,14l-1.1-1.7h-0.6v3.6h0.6v-2.6l1.1,1.7h0l1.1-1.7v2.6H64v-3.6H63.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.3,12.8h-1.1v-0.6H60v0.6h-1.1v3h-0.6V12.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.7,18.5H6l3.7,8.6H7.1l-0.6-1.5H3.1l-0.6,1.5H0L3.7,18.5z M5.8,23.7l-1-2.4l-1,2.4H5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.5,18.5h2.4V25H17v2.1h-6.6V18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.1,18.5h2.4V25h4.2v2.1h-6.6V18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.7,18.5h3.7c2.2,0,3.6,1.1,3.6,3v0c0,2-1.6,3.1-3.7,3.1h-1.2v2.5h-2.4L25.7,18.5L25.7,18.5z M29.2,22.8 c0.8,0,1.4-0.5,1.4-1.1v0c0-0.7-0.5-1.1-1.4-1.1h-1.1v2.3H29.2L29.2,22.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34,18.5h2.4v8.6H34V18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38,18.5h2.2l3.5,4.5v-4.5h2.4v8.6H44l-3.7-4.7v4.7H38L38,18.5L38,18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.4,22.9L47.4,22.9c0-2.5,2-4.5,4.6-4.5c1.5,0,2.6,0.5,3.5,1.2l-1.4,1.7c-0.6-0.5-1.2-0.8-2.1-0.8 c-1.2,0-2.2,1-2.2,2.3v0c0,1.4,1,2.4,2.3,2.4c0.6,0,1-0.1,1.4-0.4v-1h-1.7v-1.7h4V26c-0.9,0.8-2.2,1.3-3.7,1.3 C49.4,27.3,47.4,25.5,47.4,22.9L47.4,22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.5,25.8l1.3-1.6c0.9,0.7,1.8,1,2.8,1c0.7,0,1-0.2,1-0.6v0c0-0.4-0.3-0.6-1.5-0.8c-1.8-0.4-3.3-0.9-3.3-2.7 v0c0-1.6,1.3-2.7,3.3-2.7c1.5,0,2.6,0.4,3.5,1.1l-1.2,1.7c-0.8-0.6-1.7-0.8-2.4-0.8c-0.6,0-0.9,0.2-0.9,0.5v0 c0,0.4,0.3,0.6,1.5,0.8c2,0.4,3.2,1.1,3.2,2.7v0c0,1.8-1.4,2.8-3.5,2.8C59,27.3,57.5,26.8,56.5,25.8L56.5,25.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.5,0.5L32.5,0.5C32.5,0.5,32.5,0.5,32.5,0.5C32.4,0.5,32.4,0.5,32.5,0.5C32.4,0.5,32.4,0.5,32.5,0.5 L32.5,0.5L32.5,0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.5,0.4c-0.9,0-1.8,0-2.7,0L29.5,0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.5,0.5C34.5,0.5,34.5,0.5,34.5,0.5C34.5,0.5,34.5,0.5,34.5,0.5C34.5,0.5,34.4,0.5,34.5,0.5l-0.1,0.1 L34.5,0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.1,0.4c-1,0-1.8,0-2.8,0L40.1,0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.6,2.6c-1.1-1.5-2.8-2.4-4.7-2.5C40.5,0,39.1,0,37.3,0c-0.8,0-1.8,0-2.9,0c-0.1,0-0.2,0.1-0.2,0.1 c0,0,0,0-0.1,0.1L34,0.3v9.4h2.7v-7c0.1,0,0.3,0,0.5,0c1.1,0,3.3,0,4.7,0c1.2,0,2.4,0.5,3.2,1.3c0.5,0.5,0.9,1.1,1.1,1.8 c0.3,1.2,0,2.6-0.9,3.7c-0.9,1.1-2.2,1.8-3.5,1.8c-1.9,0-2.9,0-4.2,0c-0.7,0-1.4,0-2.3,0H34v5.1l0.2,0c0.1,0,0.4,0,0.8,0 c0.6,0,1.4,0,1.6,0l0.1-2.3c0.1,0,0.2,0,0.3,0c0.2,0,0.5,0,0.7,0c0.5,0,1,0,1.5,0c2.9,0.1,5.8,0.1,7.9-2l0.1-0.1c0,0,0-0.1,0.1-0.1 c0.2-0.2,0.4-0.4,0.5-0.7C49.6,8.6,49.5,5.1,47.6,2.6L47.6,2.6z M40.9,11.7C40.9,11.7,40.9,11.7,40.9,11.7L40.9,11.7L40.9,11.7z  M40.1,0.4l-2.8,0C38.3,0.4,39.2,0.4,40.1,0.4z M34.5,0.5C34.5,0.5,34.5,0.5,34.5,0.5C34.5,0.5,34.5,0.5,34.5,0.5L34.5,0.5 L34.5,0.5C34.4,0.5,34.4,0.5,34.5,0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.2,11.3c-1.3,0-2.3,0-4.2,0c-1.4,0-2.6-0.7-3.5-1.8c-0.9-1.1-1.2-2.5-0.9-3.7c0.2-0.7,0.5-1.3,1.1-1.8 c0.8-0.8,2-1.2,3.2-1.3c1.4,0,3.6,0,4.7,0c0.2,0,0.4,0,0.5,0v7h2.7V0.3l-0.1-0.1c0,0,0,0-0.1-0.1c-0.1,0-0.1-0.1-0.2-0.1 c-1.1,0-2,0-2.9,0C27.8,0,26.4,0,24,0.1c-1.9,0.1-3.6,1-4.7,2.5c-1.9,2.5-1.9,6-0.1,8.6c0.2,0.3,0.4,0.6,0.7,0.8v0 c2.1,2.2,5.1,2.1,8,2c0.5,0,5.1,0,5.1,0v-2.7h-1.3C30.6,11.3,29.9,11.3,29.2,11.3L29.2,11.3z M32.5,0.5C32.5,0.5,32.5,0.5,32.5,0.5 L32.5,0.5L32.5,0.5C32.4,0.5,32.4,0.5,32.5,0.5C32.4,0.5,32.4,0.5,32.5,0.5L32.5,0.5z M29.5,0.4l-2.7,0C27.7,0.4,28.6,0.4,29.5,0.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.1,8.3c0.7,0,1.3-0.6,1.3-1.3s-0.6-1.3-1.3-1.3c-0.7,0-1.3,0.6-1.3,1.3S40.4,8.3,41.1,8.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.5,8.2c0.7,0,1.3-0.6,1.3-1.3c0-0.7-0.6-1.3-1.3-1.3c-0.7,0-1.3,0.6-1.3,1.3C24.2,7.6,24.8,8.2,25.5,8.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logo-black.fae2501c5cd47778f6fe4103491ea467.svg";
export { ForwardRef as ReactComponent };